// Manages redirections

import { Navigate, Outlet } from "react-router-dom";
import { useAppSelector } from "../reduxToolkit/hooks";
import { routes } from "./routes";

const RouteRedirect = () => {
  const { isAuthenticated } = useAppSelector((state) => state.auth);

  if (!isAuthenticated ) {
    return <Navigate to={routes.Login} replace />;
  }

  return <Outlet />;
};

export default RouteRedirect;
